export const ITipoServico = {
    descricao: "",
    valorCusto: 0,
    valorVenda: 0,
    ativo: true,
    idfornecedor: 0,
    observacao: ""
}